import { render, staticRenderFns } from "./ZastosowanieForm.vue?vue&type=template&id=3bf1589a&"
import script from "./ZastosowanieForm.vue?vue&type=script&lang=ts&"
export * from "./ZastosowanieForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports